import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex min-h-96 max-w-md flex-col items-center justify-center gap-4 text-center">
      <p className="text-brand-600 text-5xl font-bold">404</p>
      <h1 className="text-ink text-xl font-semibold">{t('errors.notFoundTitle')}</h1>
      <p className="text-muted text-sm">{t('errors.notFoundBody')}</p>
      <Link
        to="/"
        className="bg-brand-600 hover:bg-brand-700 mt-2 inline-flex h-10 items-center rounded-lg px-4 text-sm font-medium text-white"
      >
        {t('errors.backToDashboard')}
      </Link>
    </div>
  );
}
